import { render, staticRenderFns } from "./FaceResults.vue?vue&type=template&id=2abced14&scoped=true"
import script from "./FaceResults.vue?vue&type=script&lang=js"
export * from "./FaceResults.vue?vue&type=script&lang=js"
import style0 from "./FaceResults.vue?vue&type=style&index=0&id=2abced14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abced14",
  null
  
)

export default component.exports